var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdowniconcoatable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83668 1.3562L5.39426 5.35225C5.34262 5.39905 5.2812 5.43621 5.21357 5.46159C5.14587 5.48696 5.0733 5.5 5 5.5C4.9267 5.5 4.85412 5.48696 4.78643 5.46159C4.71879 5.43621 4.65738 5.39905 4.60573 5.35225L0.163309 1.3562C0.0587455 1.26214 0 1.13457 0 1.00155C0 0.86853 0.0587455 0.740962 0.163309 0.6469C0.267878 0.552843 0.409697 0.5 0.557574 0.5C0.705451 0.5 0.847276 0.552843 0.951839 0.6469L5 4.29329L9.04815 0.6469C9.15272 0.552843 9.29454 0.5 9.44242 0.5C9.5903 0.5 9.73212 0.552843 9.83668 0.6469C9.94125 0.740962 10 0.86853 10 1.00155C10 1.13457 9.94125 1.26214 9.83668 1.3562Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdowniconcoatable);
export default __webpack_public_path__ + "static/media/dropdowniconcoatable.97e3b2528df9daa1ec16a44edaad2561.svg";
export { ForwardRef as ReactComponent };